import type { ComponentPropsWithRef } from 'react'

import AutosizeTextarea from 'react-textarea-autosize'
import styled from 'styled-components'

import { stylesFrom } from '@subaio/components'

import { DefaultInput } from '../Shared'

type Props = ComponentPropsWithRef<typeof AutosizeTextarea> & {
	isDisabled: boolean
	hasError: boolean
	maxRows: number
	minRows: number
	isFocused: boolean
	isReadOnly: boolean
	isHovered: boolean
	isFocusVisible: boolean
	hasSuffix?: boolean
}

export const Textarea = styled(AutosizeTextarea)<Props>`
	${stylesFrom(DefaultInput)}
	min-height: unset;
	height: unset;
	resize: none;
`
